import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X, MessageCircle } from "lucide-react";
import { buildGeneralWhatsAppLink, getDefaultWhatsAppMessage } from "@/utils/whatsapp";
import { trackClickWhatsApp } from "@/utils/analytics";

export const DASHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleWhatsAppClick = () => {
    trackClickWhatsApp('global');
    window.open(buildGeneralWhatsAppLink(getDefaultWhatsAppMessage()), '_blank');
  };

  const scrollToSection = (sectionId: string) => {
    setMobileMenuOpen(false);
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-border h-16">
      <div className="container mx-auto px-4 h-full">
        <div className="flex items-center justify-between h-full">
          {/* Logo */}
          <a href="https://dasgroup.ch" target="_blank" rel="noopener noreferrer" className="flex items-center hover:opacity-80 transition-opacity">
            <img src="/das-group-logo.svg" alt="DAS Group AG" className="h-12 w-auto" />
          </a>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('cars-section')} className="text-gray-700 hover:text-gold transition-colors">
              Fahrzeuge
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-gray-700 hover:text-gold transition-colors">
              So funktioniert's
            </button>
            <button onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-gold transition-colors">
              Preise
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-gold transition-colors">
              FAQ
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-gold transition-colors">
              Kontakt
            </button>
          </nav>
          
          {/* Desktop CTA */}
          <div className="hidden md:block">
            <Button 
              onClick={handleWhatsAppClick}
              className="bg-gold hover:bg-gold-hover text-white font-semibold transition-colors duration-200"
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              WhatsApp
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-b border-border">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-4">
            <button onClick={() => scrollToSection('cars-section')} className="text-left text-gray-700 hover:text-gold transition-colors py-2">
              Fahrzeuge
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-left text-gray-700 hover:text-gold transition-colors py-2">
              So funktioniert's
            </button>
            <button onClick={() => scrollToSection('pricing')} className="text-left text-gray-700 hover:text-gold transition-colors py-2">
              Preise
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-left text-gray-700 hover:text-gold transition-colors py-2">
              FAQ
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-left text-gray-700 hover:text-gold transition-colors py-2">
              Kontakt
            </button>
            <Button 
              onClick={handleWhatsAppClick}
              className="bg-gold hover:bg-gold-hover text-white font-semibold w-full transition-colors duration-200"
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              WhatsApp
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};
